var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgetAutofill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5h5M11.5 3.827c.221-.21.52-.327.833-.327.155 0 .308.029.451.085.143.056.273.138.383.242.11.103.196.226.255.361a1.062 1.062 0 0 1 0 .854c-.06.135-.146.258-.255.362l-6.945 6.57L4 12.5l.556-2.103 6.944-6.57z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetAutofill);
export default __webpack_public_path__ + "static/media/widgetAutofill.2392d5e19bb9718259ec80e13f43ce0c.svg";
export { ForwardRef as ReactComponent };